import { render, staticRenderFns } from "./TelegramIcon.vue?vue&type=template&id=252bfa77&scoped=true"
import script from "./TelegramIcon.vue?vue&type=script&lang=js"
export * from "./TelegramIcon.vue?vue&type=script&lang=js"
import style0 from "./TelegramIcon.vue?vue&type=style&index=0&id=252bfa77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252bfa77",
  null
  
)

export default component.exports